import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-audit-log-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42936_28579)">
        <path
          d="M4 17.333H6.66667V14.6663H4V17.333ZM4 22.6663H6.66667V19.9997H4V22.6663ZM4 11.9997H6.66667V9.33301H4V11.9997ZM9.33333 17.333H28V14.6663H9.33333V17.333ZM9.33333 22.6663H28V19.9997H9.33333V22.6663ZM9.33333 9.33301V11.9997H28V9.33301H9.33333ZM4 17.333H6.66667V14.6663H4V17.333ZM4 22.6663H6.66667V19.9997H4V22.6663ZM4 11.9997H6.66667V9.33301H4V11.9997ZM9.33333 17.333H28V14.6663H9.33333V17.333ZM9.33333 22.6663H28V19.9997H9.33333V22.6663ZM9.33333 9.33301V11.9997H28V9.33301H9.33333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_42936_28579">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditLogIconComponent {}
